import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type {
  FanguardApiContractsClientCampaignDetailModel,
  FanguardApiContractsClientSiteDetailModel,
} from 'src/api/generated';

export const SITE_URI = 'site';

export const siteQueries = createQueryKeys(SITE_URI, {
  all: null,
  details: {
    queryKey: ['details'] as const,
    queryFn: async () => {
      const response = await get<FanguardApiContractsClientSiteDetailModel[]>({ uri: `${SITE_URI}/details` });
      return response.data;
    },
  },
  list: {
    queryKey: ['list'] as const,
    queryFn: async () => {
      const response = await get<FanguardApiContractsClientSiteDetailModel[]>({ uri: SITE_URI });
      return response.data;
    },
  },
  detail: (id: string) => ({
    queryKey: [id],
    queryFn: async () => {
      const response = await get<FanguardApiContractsClientSiteDetailModel>({ uri: `${SITE_URI}/${id}` });
      return response.data;
    },
  }),
  campaign: (siteId: string, campaignId: string) => ({
    queryKey: [siteId, campaignId],
    queryFn: async () => {
      const response = await get<FanguardApiContractsClientCampaignDetailModel>({
        uri: `${SITE_URI}/${siteId}/campaign/${campaignId}`,
      });
      return response.data;
    },
  }),
});
